<template>
  <td>{{ game }}</td>
</template>

<script>
  export default {
    name: "TableBlueLabelValue",
    props: ['value']
  }
</script>

<style scoped>
  td {
    text-align: center !important;
  }
</style>
